module.exports = __webpack_public_path__ + "img/007 사회와법률-난민-신문.c2df48c1.png";